/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import ImpersonateService from '@/services/Impersonate/ImpersonateService'

export default () => ({
    companiesConfig: {
        include: 'form,status,company, created_by',
        sort: 'id',
        sortDirection: '',
        page: 1,
        filters: '',
        per_page: 15
    },
    companies: null,
    company: null,
    companyStats: null,
    companySettings: null,
    companyHeaderMail: null,
    statuses: null,
    companiesFilters: null,
    newCompany: {
        attributes: {}
    },
    isUnderImpersonation: new ImpersonateService().underImpersonation(),
    userImpersonated: new ImpersonateService().userImpersonated(),
    templates: [],
    templatesConfig: {
        sort: 'id',
        sortDirection: 'desc',
        page: 1,
        filters: {},
        per_page: 15
    },
    templatesFilters: null,
    template: null,
    pagination: null
})
